import {
  getFormData,
  getSubmission,
} from 'platform/forms-system/src/js/state/selectors';
import { formatFullName } from 'platform/shared/health-apps';
import { HIGH_DISABILITY_MINIMUM } from '../utils/constants';

/**
 * Derive the values displayed on the confirmation page. The returned object is
 * new on every call, so use it with `useSelector` and `shallowEqual`.
 *
 * @param {Object} state - Redux state
 * @returns {Object} the submission timestamp, display name and FAQ flags
 */
export const selectConfirmationPageData = state => {
  const formData = getFormData(state);
  const { veteranFullName } = formData['view:veteranInformation'] ?? {};

  return {
    timestamp: getSubmission(state).response?.timestamp,
    submissionName: formatFullName(veteranFullName, { includeMiddle: true }),
    hasTeraResponse: formData.hasTeraResponse,
    hasHighCompensation:
      formData.vaCompensationType === 'highDisability' ||
      formData['view:totalDisabilityRating'] >= HIGH_DISABILITY_MINIMUM,
  };
};
